import { useCallback, useEffect, useRef, useState } from 'react';

import { localStorage } from '../../utils/storage/storage';

import { SELECTED_SWATCHES } from '../../constants/storage-keys';

function getSwatchFromStorage(productCode) {
  return localStorage(SELECTED_SWATCHES)?.[productCode];
}

/**
 * @param onlyUseFirstProductCode By default, any productCode passed to this hook
 * at any time is used.  If you only want the first productCode passed to this hook
 * to be used, then set this to true.
 */
function useProductSwatchSelection(
  productCode,
  swatches,
  onlyUseFirstProductCode = false
) {
  const swatchProductCodeRef = useRef(productCode);
  const [selectedSwatch, setSelectedSwatch] = useState(() =>
    getSwatchFromStorage(productCode)
  );

  useEffect(() => {
    if (!onlyUseFirstProductCode || !swatchProductCodeRef.current) {
      swatchProductCodeRef.current = productCode;
      const storedSwatch = getSwatchFromStorage(productCode);
      if (storedSwatch && !selectedSwatch) {
        setSelectedSwatch(storedSwatch);
      }
    }
  }, [onlyUseFirstProductCode, productCode, selectedSwatch]);

  const saveSelectedSwatch = useCallback(swatch => {
    const productCode = swatchProductCodeRef.current;
    if (
      !productCode ||
      (!swatch.color && !swatch.finish && !swatch.code && !swatch.hexCode)
    ) {
      return;
    }

    const newSwatches = localStorage(SELECTED_SWATCHES) || {};
    newSwatches[productCode] = swatch;

    localStorage(SELECTED_SWATCHES, newSwatches);
    setSelectedSwatch(swatch);
  }, []);

  return {
    saveSelectedSwatch,
    selectedSwatch:
      selectedSwatch || (Array.isArray(swatches) ? swatches[0] : undefined)
  };
}

export default useProductSwatchSelection;
